import PropTypes from "prop-types";
import AgentTextsRow from "./AgentTextsRow";
import AgentTextsTotalRow from "./AgentTextsTotalRow";

const AgentTextsHolder = ({ agentTextData }) => (
  <>
    {agentTextData.textData.map((a) => (
      <AgentTextsRow key={a.id} agent={a} />
    ))}

    {agentTextData.textData.length > 1 && <AgentTextsTotalRow reportData={agentTextData.textData} />}
  </>
);

AgentTextsHolder.propTypes = {
  agentTextData: PropTypes.shape().isRequired,
};

export default AgentTextsHolder;
